import { getAncestorsForConstructor } from './target_properties';
export function blessState(constructor, module) {
  const initialStateProperties = getInitialStatePropertiesForConstructor(constructor);
  initialStateProperties.forEach(property => addInitialState(module, property));
}
function getInitialStatePropertiesForConstructor(constructor) {
  const ancestors = getAncestorsForConstructor(constructor);
  return Array.from(ancestors.reduce((initialStateProperties, constructor) => {
    getOwnInitialStatePropertiesForConstructor(constructor).forEach(property => initialStateProperties.add(property));
    return initialStateProperties;
  }, new Set()));
}
function getOwnInitialStatePropertiesForConstructor(constructor) {
  const definition = constructor['initialState'];
  return Array.isArray(definition) ? definition : [];
}
function addInitialState(module, property) {
  if (!module.data.has(property.name)) {
    console.info(`Can't find ${module.data._getFormattedKey(property.name)} on ${module.identifier}'s element so can't set the initial state for it`);
  }
  switch (property.type) {
    case Number:
      {
        module.state.addKey(property.name, parseInt(module.data.get(property.name), 10));
        break;
      }
    case Boolean:
      {
        module.state.addKey(property.name, module.data.get(property.name) === 'true');
        break;
      }
    default:
      {
        module.state.addKey(property.name, module.data.get(property.name));
      }
  }
}